import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import $ from "jquery";

export default class AjaxFulltextFilter extends WebComponent {
  didMount() {
    const fulltextfilter = this.element;
    fulltextfilter.onchange = function(){
      var searchFormAction = $('.search-form').attr('action');
      var searchFormQuery = $('.search-form input').val();
      var value = fulltextfilter.options[fulltextfilter.selectedIndex].value;
      $(".fulltext__results").load(searchFormAction + '?frm.query=' + encodeURI(searchFormQuery) + '&frm.facultyCategory=' + value + ' #result');
    };

    /*fulltextfilter.change(function(){
      e.preventDefault();
      console.log(categoryContainer);
      var value = $(this).val();
      var searchFormAction = $('.search-form').attr('action');
      var searchFormQuery = $('.search-form input').val();
      $(".fulltext__results").load(searchFormAction + '?frm.query=' + searchFormQuery + '&frm.facultyCategory=' + value + ' #result');

    })*/
  }
}





// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/AjaxFulltextFilter.js